import React, { createContext, useState, useEffect, useContext } from 'react';
import { authService } from '../services/authService';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
   const [user, setUser] = useState(null);
   const [loading, setLoading] = useState(true);

   useEffect(() => {
      const initAuth = async () => {
         const storedUser = authService.getStoredUser();
         if (storedUser && authService.isAuthenticated()) {
            try {
               const response = await authService.getCurrentUser();
               if (response.success) {
                  setUser(response.data);
               } else {
                  authService.logout();
               }
            } catch (error) {
               if (error.response?.status === 401) {
                  authService.logout();
               } else {
                  setUser(storedUser);
               }
            }
         }
         setLoading(false);
      };

      initAuth();
   }, []);

   const login = async (credentials) => {
      const response = await authService.login(credentials);
      if (response.success) {
         setUser(response.data.user);
         return { success: true };
      }
      return { success: false, error: response.error || 'Login failed' };
   };

   const register = async (userData) => {
      const response = await authService.register(userData);
      if (response.success) {
         setUser(response.data.user);
         return { success: true };
      }
      return { success: false, error: response.error || 'Registration failed' };
   };

   const logout = () => {
      authService.logout();
      setUser(null);
   };

   const refreshUser = async () => {
      try {
         const response = await authService.getCurrentUser();
         if (response.success) {
            setUser(response.data);
            if (typeof window !== 'undefined') {
               localStorage.setItem('user', JSON.stringify(response.data));
            }
         }
      } catch (error) {
         console.error('Failed to refresh user:', error);
      }
   };

   const value = {
      user,
      loading,
      login,
      register,
      logout,
      refreshUser,
      isAuthenticated: !!user,
   };

   return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
   const context = useContext(AuthContext);
   if (!context) {
      throw new Error('useAuth must be used within an AuthProvider');
   }
   return context;
};
